export default __webpack_public_path__ + "static/media/Spray 2.d8237940.png";